module.exports = __webpack_public_path__ + "static/2014-tray-4f9a9ddb333aec3ccf802f2620caeeb1.jpg";